// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"557":"polyfill-fetch","594":"jsencrypt","798":"polyfill-standard-library"}[chunkId] + ".js";
};